import React, {Component} from 'react';
import ChartPane from './components/chart';
import FeatureFlagForm from './components/common/feature_flag_form';
import Pipeline from './components/pipeline';
import {FEATURE_FLAGS, onFlagChange} from './services/feature_flags';
import {globalClickEvent} from './services/global_events';
import {currentPipeline} from './utils/pipeline_utils';
import DATASOURCES from "./services/datasources";
import {queryBuilderState} from "./services/query_builder_state";
import {ATTRIBUTES, createDatasetAttribute} from "./utils/query_utils";
import {columnSelectEvent} from "./services/query_builder_events";

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pipeline: currentPipeline,
            showFeatureFlagForm: false,
            showFeatureFlags: false,
            queryBuilderType: FEATURE_FLAGS.QUERY_BUILDER_TYPE,
        };

        this.addOrUpdateStep = this.addOrUpdateStep.bind(this);
        this.removeStep = this.removeStep.bind(this);
        this.toggleFeatureFlagForm = this.toggleFeatureFlagForm.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
        setTimeout(async () => {
            const start = Date.now();
            console.debug('seeding database');
            await Promise.all(Object.values(DATASOURCES).map(source => source.initDB()));
            this.preselectColumns();
            console.debug('database seeded', Date.now() - start);
        }, 250);
        onFlagChange('QUERY_BUILDER_TYPE', (queryBuilderType) => {
            this.setState({queryBuilderType})
        });
    }

    preselectColumns() {
        if (FEATURE_FLAGS.PRESELECT_COLUMNS) {
            const chinook = DATASOURCES.chinook.getSchema('music');
            const artists = chinook.getTable('artists');
            const genre = chinook.getTable('genres');
            const tracks = chinook.getTable('tracks');
            const dataset = this.state.pipeline.steps[0];

            queryBuilderState.attribute = createDatasetAttribute(ATTRIBUTES.COLUMN, dataset);
            columnSelectEvent.emit(artists.getColumnByName('Artist Name'));

            queryBuilderState.attribute = createDatasetAttribute(ATTRIBUTES.COLUMN, dataset);
            columnSelectEvent.emit(genre.getColumnByName('Genre Name'));

            queryBuilderState.attribute = createDatasetAttribute(ATTRIBUTES.COLUMN, dataset);
            columnSelectEvent.emit(tracks.getColumnByName('Track Unit Price'));
        }
    }

    addOrUpdateStep(step) {
        const {pipeline} = this.state;
        pipeline.addOrUpdateStep(step);
        pipeline.run();
        this.setState({pipeline});
    }

    removeStep(step) {
        const {pipeline} = this.state;
        pipeline.removeStep(step);
        pipeline.run();
        this.setState({pipeline});
    }

    toggleFeatureFlagForm() {
        this.setState({showFeatureFlagForm: !this.state.showFeatureFlagForm});
    }

    handleKeyDown(ev) {
        switch (ev.key) {
            case 'F':
                this.setState({showFeatureFlags: true});
                break;
            default:
                break;
        }
    }

    render() {
        const {pipeline, showFeatureFlags, showFeatureFlagForm, queryBuilderType} = this.state;
        return (
            <div
                onClick={() => globalClickEvent.emit()}
                style={{width: '100%', height: '100%'}}
                className={queryBuilderType}
            >
                <div className="menu">
                    {/*<img src="images/chartio-logo.svg" alt="" className="image" />*/}
                    <div className="logo menu-item">Data Analytics App</div>
                    <div className="menu-item active">Explore</div>
                    {showFeatureFlags && (
                        <>
                            <div
                                className={`menu-item menu-item-right ${showFeatureFlagForm ? 'active' : ''}`}
                                onClick={this.toggleFeatureFlagForm}
                            >
                                Flags
                            </div>
                            {showFeatureFlagForm && <FeatureFlagForm />}
                        </>
                    )}

                </div>
                <div className="section">
                    <div className="horizontal-flex">
                        <Pipeline
                            pipeline={pipeline}
                            addOrUpdateStep={this.addOrUpdateStep}
                            removeStep={this.removeStep}
                        />
                        <ChartPane />
                    </div>
                </div>
            </div>
        );
    }
}
